/* tslint:disable:max-classes-per-file  */
import { key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APProgramSlotServant } from '../servants/ap_program_slot_servant';
import { ap_course_status_type } from '../strategies/ap_course_status_strategy';
import { APCourse } from './ap_course_builder';
import { APCourseGroup } from './ap_course_group_builder';
import { slotType } from './ap_generic_slot_builder';
import { APGradeConfig } from './ap_gradeconfig_builder';
export interface IAPProgramSlotCourse {
  course_id: number;
}

export interface IAPProgramSlotMeta {
  id: key;
  _selectedCourses: string;
  _course_ids?: number[];
  _courses?: APCourse[];
  _course_group: APCourseGroup;
  _term_id: number;
  _grade_config?: APGradeConfig;
}

export class ProgramSlot {
  id: key;
  slot_type: slotType;
  slot: number;
  status: ap_course_status_type;
  term_slot_group: number;
}

export class SingleCourseProgramSlot extends ProgramSlot {
  slot_type: 'COURSE';
  courses: [IAPProgramSlotCourse];
  course_group: string;
  desc: string;
  is_course_planned: boolean;
  is_devreq: boolean;
  min_credits: number;
  max_credits: number;
  total_courses: number = 1;
  min_grade_point: number;
  showGradeBadge: boolean;
  shouldShowAddToTermMenu: boolean;
  isMinGradeMet: boolean;
  isCourseCompleted: boolean;

  constructor(programSlot: Partial<SingleCourseProgramSlot>) {
    super();
    _4.merge(this, {}, programSlot);
    return this;
  }
}

export class CourseGroupProgramSlot extends ProgramSlot {
  slot_type: 'GROUP';
  courses: IAPProgramSlotCourse[];
  course_group: string;
  desc: string;
  is_course_group_planned: boolean;
  is_course_planned: boolean;
  is_devreq: boolean;
  min_credits: number;
  max_credits: number;
  total_courses: number;
  min_grade_point: number;
  showGradeBadge: boolean;
  constructor(courseGroupProgramSlot: Partial<CourseGroupProgramSlot>) {
    super();
    _4.merge(this, {}, courseGroupProgramSlot);
    return this;
  }
}

export class WildcardProgramSlot extends ProgramSlot {
  slot_type: 'WILDCARD';
  courses: IAPProgramSlotCourse[];
  course_group: string;
  instructions: string;
  desc: string | null;
  is_devreq: boolean;
  is_course_group_planned: boolean;
  is_course_planned: boolean;
  min_credits: number;
  max_credits: number;
  constructor(wildcardProgramSlot: Partial<WildcardProgramSlot>) {
    super();
    _4.merge(this, {}, wildcardProgramSlot);
    return this;
  }
}

export class NCRProgramSlot extends ProgramSlot {
  slot_type: 'NCR';
  course_group: string;
  desc: string;
  instructions: string;
  is_course_group_planned: boolean;
  constructor(ncrProgramSlot: NCRProgramSlot) {
    super();
    _4.merge(this, {}, ncrProgramSlot);
    return this;
  }
}

export type APProgramSlot = CourseGroupProgramSlot | SingleCourseProgramSlot | WildcardProgramSlot | NCRProgramSlot;

export class ProgramSlotMeta {
  id: key;
  slot_type: slotType;
}

export class SingleCourseProgramSlotMeta extends ProgramSlotMeta {
  slot_type: 'COURSE';
  _course_ids: [number];
  _courses: [APCourse];
  _term_id: number;
}

export class CourseGroupProgramSlotMeta extends ProgramSlotMeta {
  slot_type: 'GROUP';
  _course_ids: number[];
  _courses: APCourse[];
  _course_group: APCourseGroup;
  _term_id: number;
}

export class WildcardProgramSlotMeta extends ProgramSlotMeta {
  slot_type: 'WILDCARD';
  _course_ids: number[];
  _courses: APCourse[];
  _course_group: APCourseGroup;
  _term_id: number;
}

export type APProgramSlotMeta = CourseGroupProgramSlotMeta | SingleCourseProgramSlotMeta | WildcardProgramSlotMeta;

export class APProgramSlotBuilder {
  course_group?: string;
  courses?: IAPProgramSlotCourse[];
  desc: string;
  id: key;
  slot_type: APProgramSlotMeta['slot_type'];
  instructions?: string;
  is_course_group_planned: boolean;
  is_course_planned: boolean;
  is_devreq: boolean;
  slot: number;
  status: ap_course_status_type;
  term_slot_group: number;
  total_courses: number;
  min_credits?: number;
  max_credits?: number;

  constructor(programSlot: Partial<APProgramSlot>) {
    _4.merge(this, {}, programSlot);
    return this;
  }

  static build(programSlot: SingleCourseProgramSlot): SingleCourseProgramSlot;
  static build(programSlot: CourseGroupProgramSlot): CourseGroupProgramSlot;
  static build(programSlot: WildcardProgramSlot): WildcardProgramSlot;
  static build(programSlot: NCRProgramSlot): NCRProgramSlot;

  static build(programSlot: APProgramSlot): APProgramSlot {
    if (APProgramSlotServant.isCourseProgramSlot(programSlot)) {
      return new SingleCourseProgramSlot(programSlot);
    } else if (APProgramSlotServant.isWildcardProgramSlot(programSlot)) {
      return new WildcardProgramSlot(programSlot);
    } else if (APProgramSlotServant.isCourseGroupProgramSlot(programSlot)) {
      return new CourseGroupProgramSlot(programSlot);
    } else {
      return new NCRProgramSlot(programSlot);
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/builders/ap_program_slot_builder.ts